
/*
  Function name : get_api_key
  Description : AJAX request to get the booxi api key for each "book" button
  Params :
    - (id) The space ID of the book category (ps, beauty, visits etc...)
 */
const get_api_key = (id) => {
  return fetch('/wp-json/booxi/v1/api', {
    method: 'post',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      'service_type': id, // the space ID
    }),
  }).then(resp => resp.text());
}

window.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('[data-booxi]');

  window.bxApiInit = async function() { // we store the booxi API on the window variables
    const ho_key = await get_api_key('ho'); // getting the main API key

    const bnHandler = booxiController.configure({ // init the Booxi sdk with the global key (HO)
      apiKey: ho_key
    });

    [...buttons].map(async (button, index) => { // for each button we add a new profile on the booxi handler
      const api_key = await get_api_key(button.dataset.booxi); // getting the key from env variable

      // getting the tags/id stored in the dataset, to show the right category (service tag, category tag, language)
      const service_tags = button.dataset.booxiCatTags;
      const category_ids = button.dataset.booxiCatIds;
      const language = button.dataset.booxiLang;

      bnHandler.addingBookingProfile(button.id, { // method to add the new booxi profile
        apiKey: api_key,
        language: language,
        serviceTags: service_tags,
        serviceCategoryId: category_ids,
      });
    });
  };
});
